module.exports = __webpack_public_path__ + "img/hunzhiCode.97bb733c.jpeg";